<template>
  <div class="grid grid-cols-1 gap-4 items-start lg:grid-cols-3 lg:gap-8">
    <!-- Left column -->
    <div class="grid grid-cols-1 gap-4 lg:col-span-2">

      <section>
        <div class="rounded-lg bg-white overflow-hidden shadow">
          <div class="bg-white px-4 py-5 border-b border-gray-200 sm:px-6">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Зарегистрированные пользователи
            </h3>
            <p class="mt-1 text-sm text-gray-500">
              Список всех зарегистрированных пользователей, вы можете редактировать персональны данные и назначать
              администраторов.
            </p>

            <div class="flex flex-col mt-4">
              <ui-search-box class="mb-4" v-model="search"/>


              <ui-table :rows="users.data">
                <ui-table-col label="#" prop="index" :from="users.from"/>
                <ui-table-col label="Имя">
                  <template #default="{row}">
                    <div class="flex items-center">
                      <div>
                        <ui-avatar-circular cls="h-9 w-9" :name="row.name"/>
                      </div>
                      <div class="ml-3">
                        <p>
                          <router-link :to="{name: 'UserProfile', params: {user_id: row.id}}"
                                       class="text-sm font-medium text-gray-700 group-hover:text-gray-900">
                            {{ row.name }}
                          </router-link>
                        </p>
                        <a :href="`mailto:${row.email}`"
                           class="text-xs font-medium text-primary-600 group-hover:text-primary-700">
                          {{ row.email }}
                        </a>
                      </div>
                    </div>
                  </template>
                </ui-table-col>
                <ui-table-col label="id" prop="id"/>
                <ui-table-col label="Доступ">
                  <template #default="{row}">
                    <ui-badge :color="row.user_role_id === 2 ? 'green': 'red'">
                      {{ row.user_role_id === 2 ? 'Куратор' : 'Администратор' }}
                    </ui-badge>
                  </template>
                </ui-table-col>
                <ui-table-col label="Активность" class="text-right whitespace-nowrap text-sm text-gray-500">
                  <template #default="{row}">
                    {{ row.token_refreshed_at ? $date.formatRelative(row.token_refreshed_at) : '' }}
                  </template>
                </ui-table-col>
              </ui-table>
            </div>

            <ui-pagination :current="users.current_page" :from="users.from" :to="users.to" :last="users.last_page"
                           :total="users.total" @change="setUserPage"/>
          </div>


        </div>
      </section>


    </div>

    <!-- Right column -->
    <div class="grid grid-cols-1 gap-4">

      <!-- Recent Hires -->
      <section aria-labelledby="recent-hires-title">
        <div class="rounded-lg bg-white overflow-hidden shadow">
          <div class="p-6">
            <h2 class="text-base font-medium text-gray-900">Недавние регистрации</h2>
            <div class="flow-root mt-6">
              <ul class="-my-5 divide-y divide-gray-200">


                <router-link :to="{name: 'UserProfile', params:{user_id: user.id}}" v-for="user in lasts"
                             :key="user.id" custom
                             v-slot="{ href, navigate, }"
                >
                  <li class="py-4">

                    <a class="flex items-center space-x-4" :href="href" @click="navigate">
                      <div class="flex-shrink-0">
                        <!--                        <img class="h-8 w-8 rounded-full" :src="user.photo.url"
                                                     alt="user">-->
                      </div>
                      <div class="flex-1 min-w-0">
                        <p class="text-sm font-medium text-gray-900 truncate">
                          {{ user.name }}
                        </p>
                        <p class="text-sm text-gray-500 truncate">
                          {{ user.email }}
                        </p>
                      </div>
                    </a>


                  </li>
                </router-link>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import UiPagination from "@/components/ui/UiPagination";
import UiSearchBox from "@/components/ui/UiSearchBox";
import UiTable from "@/components/ui/table/UiTable";
import UiTableCol from "@/components/ui/table/UiTableCol";
import UiAvatarCircular from "@/components/ui/elements/avatars/UiAvatarCircular";
import UiBadge from "@/components/ui/elements/badges/UiBadge";

export default {
  name: "Users",
  components: {UiBadge, UiAvatarCircular, UiTableCol, UiTable, UiSearchBox, UiPagination},
  data() {
    return {
      lasts: [],
      users: {},
      search: ''
    }

  },
  methods: {
    async setUserPage(page) {
      this.users = await this.$api.users.paginate(page, this.search)
    },

  },
  watch: {
    search() {
      //console.log(this.search)
      this.setUserPage(1);
    }
  },
  async mounted() {
    this.users = await this.$api.users.paginate()
    this.lasts = await this.$api.users.lastRegistrations();
  }

}
</script>

<style scoped>

</style>